export const INVOICES_REPORT_DEFAULT_INCLUDES = [
  'application',
  'sh-invoice-line-items.application',
  'child-sh-invoices.sh-invoice-line-items.application',
  'child-sh-invoices.application',
];

export const ADMIN_CREDIT_INVOICES_DEFAULT_INCLUDES = [
  'related.cost-code',
  'sh-general-invoice-transactions',
];

export const ADMIN_CREDIT_DEFAULT_INCLUDES = [
  'sh-general-invoice',
  'sh-general-invoice.sh-general-invoice-transactions',
  'cost-code',
];

export const PAGINATION_DEFAULT_COUNT_PER_PAGE = 10;

/**
 * Object representing JSON for factoids
 *
 * @type {Object}
 */
export const FACTOIDS_FAKE_JSON_DATA = {
  "data": [{
    "type": "Factoid",
    "id": "3804680382",
    "attributes": {
      "type": "spend",
      "title": "Earnings YTD",
      "fact": "$85,134",
      "fact-unit": null,
      "sub-title": null
    }
  }, {
    "type": "Factoid",
    "id": "404956735",
    "attributes": {
      "type": "spend",
      "title": "Paid out YTD",
      "fact": "$85,134",
      "fact-unit": null,
      "sub-title": null
    }
  }, {
    "type": "Factoid",
    "id": "4060074292",
    "attributes": {
      "type": "spend",
      "title": "Upcoming payments",
      "fact": "$12,234",
      "fact-unit": null,
      "sub-title": null
    }
  }]
};

/**
 * Object representing JSON for projects
 *
 * @type {Object}
 */
export const PROJECTS_FAKE_JSON_DATA = {
  "data": [{
    "type": "FreelancerProjectMetrics",
    "id": "1",
    "attributes": {
      "project-id": 1,
      "title": "Project 1",
      "payment-id": 1,
      "buyer-company-name": "Glimmer Studio",
      "amount": "4900.00",
      "completed-at": "2017-01-13T21:35:04+00:00",
      "started-at": "2016-08-19T18:29:51+00:00",
      "paid-at": "2017-02-03T20:10:25+00:00",
      "payout-at": "2017-02-03T20:10:25+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "2",
    "attributes": {
      "project-id": 2,
      "title": "Project 2",
      "payment-id": 2,
      "buyer-company-name": "Glimmer Studio",
      "amount": "1500.00",
      "completed-at": "2017-03-31T15:18:55+00:00",
      "started-at": "2017-03-31T15:17:21+00:00",
      "paid-at": "2017-04-21T14:33:07+00:00",
      "payout-at": "2017-04-21T14:33:07+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "3",
    "attributes": {
      "project-id": 3,
      "title": "Project 3",
      "payment-id": 3,
      "buyer-company-name": "Glimmer Studio",
      "amount": "200.00",
      "completed-at": "2017-05-15T20:09:40+00:00",
      "started-at": "2017-05-15T20:03:08+00:00",
      "paid-at": "2017-06-02T15:26:15+00:00",
      "payout-at": "2017-06-02T15:26:15+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "4",
    "attributes": {
      "project-id": 4,
      "title": "Project 4",
      "payment-id": 4,
      "buyer-company-name": "Glimmer Studio",
      "amount": "1800.00",
      "completed-at": "2017-06-13T22:08:37+00:00",
      "started-at": "2017-05-17T15:11:29+00:00",
      "paid-at": "2017-07-07T14:26:28+00:00",
      "payout-at": "2017-07-07T14:26:28+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "5",
    "attributes": {
      "project-id": 5,
      "title": "Project 5",
      "payment-id": 5,
      "buyer-company-name": "Glimmer Studio",
      "amount": "200.00",
      "completed-at": "2017-05-23T00:06:28+00:00",
      "started-at": "2017-05-23T00:02:33+00:00",
      "paid-at": "2017-06-09T15:02:12+00:00",
      "payout-at": "2017-06-09T15:02:12+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "6",
    "attributes": {
      "project-id": 6,
      "title": "Project 6",
      "payment-id": 6,
      "buyer-company-name": "Glimmer Studio",
      "amount": "4736.38",
      "completed-at": "2017-09-14T15:07:11+00:00",
      "started-at": "2017-09-14T14:40:11+00:00",
      "paid-at": "2017-10-06T15:02:40+00:00",
      "payout-at": "2017-10-06T15:02:40+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "7",
    "attributes": {
      "project-id": 7,
      "title": "Project 7",
      "payment-id": 7,
      "buyer-company-name": "Glimmer Studio",
      "amount": "8046.00",
      "completed-at": "2017-10-07T01:19:57+00:00",
      "started-at": "2017-10-07T01:18:36+00:00",
      "paid-at": "2017-10-27T14:34:24+00:00",
      "payout-at": "2017-10-27T14:34:24+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "8",
    "attributes": {
      "project-id": 8,
      "title": "Project 8",
      "payment-id": 8,
      "buyer-company-name": "Glimmer Studio",
      "amount": "4600.00",
      "completed-at": "2017-11-02T15:29:54+00:00",
      "started-at": "2017-11-02T12:15:00+00:00",
      "paid-at": "2017-11-22T16:10:26+00:00",
      "payout-at": "2017-11-22T16:10:26+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "9",
    "attributes": {
      "project-id": 9,
      "title": "Project 9",
      "payment-id": 9,
      "buyer-company-name": "Glimmer Studio",
      "amount": "6500.00",
      "completed-at": "2017-12-11T17:22:34+00:00",
      "started-at": "2017-12-09T19:00:50+00:00",
      "paid-at": "2017-12-29T17:56:26+00:00",
      "payout-at": "2017-12-29T17:56:26+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }, {
    "type": "FreelancerProjectMetrics",
    "id": "10",
    "attributes": {
      "project-id": 10,
      "title": "Project 10",
      "payment-id": 10,
      "buyer-company-name": "Glimmer Studio",
      "amount": "3000.00",
      "completed-at": "2017-12-20T16:48:10+00:00",
      "started-at": "2017-12-20T16:45:15+00:00",
      "paid-at": "2018-01-12T16:53:44+00:00",
      "payout-at": "2018-01-12T16:53:44+00:00",
      "start-date": "2016-12-31T23:00:00+00:00",
      "end-date": "2017-12-31T23:00:00+00:00"
    }
  }]
};
